import React from 'react';
import PropTypes from 'prop-types';

export default function IconRotate({ className, style, fill, right }) {
  return (
    <svg
      className={className}
      fill="none"
      height="15"
      style={{ ...style, transform: right ? 'rotateX(0deg) rotateY(180deg)' : 'rotate(0deg)' }}
      viewBox="0 0 14 15"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.82657 5.25444C3.55824 4.9861 3.09741 5.03277 2.91657 5.36527C2.75324 5.66277 2.62491 5.9661 2.52574 6.28694C2.41491 6.65444 2.70657 7.0161 3.08574 7.0161H3.09157C3.34241 7.0161 3.56991 6.85277 3.63991 6.60777C3.70991 6.37444 3.80324 6.14694 3.91991 5.92527C4.04824 5.70944 4.00741 5.43527 3.82657 5.25444ZM3.09741 8.18277H3.08574C2.70657 8.18277 2.41491 8.54444 2.52574 8.91194C2.61907 9.22694 2.74741 9.5361 2.91074 9.8336C3.09157 10.1661 3.55824 10.2186 3.82657 9.95027C4.00157 9.76944 4.04824 9.5011 3.92574 9.27944C3.80907 9.0636 3.71574 8.8361 3.64574 8.60277C3.57574 8.3461 3.34824 8.18277 3.09741 8.18277ZM4.75991 11.6944C5.05741 11.8578 5.36657 11.9861 5.68741 12.0794C6.04907 12.1844 6.41074 11.8928 6.41074 11.5194V11.5019C6.41074 11.2511 6.24741 11.0236 6.00241 10.9536C5.76907 10.8836 5.54741 10.7903 5.33157 10.6736C5.10991 10.5511 4.82991 10.5919 4.65491 10.7728L4.63741 10.7903C4.37491 11.0528 4.42741 11.5136 4.75991 11.6944ZM7.58324 2.9736V2.5886C7.58324 2.06944 6.95324 1.80694 6.58574 2.17444L5.34907 3.41694C5.11574 3.65027 5.11574 4.0236 5.34907 4.2511L6.59157 5.46444C6.95907 5.8261 7.58324 5.5636 7.58324 5.04444V4.15194C9.23991 4.43194 10.4999 5.86694 10.4999 7.59944C10.4999 9.19194 9.43824 10.5278 7.97991 10.9536C7.74074 11.0236 7.58324 11.2511 7.58324 11.5019V11.5136C7.58324 11.8928 7.93907 12.1786 8.30074 12.0736C10.2491 11.5136 11.6666 9.72277 11.6666 7.59944C11.6666 5.21944 9.88741 3.25944 7.58324 2.9736Z"
        fill={fill}
      />
    </svg>
  );
}

IconRotate.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  right: PropTypes.bool,
  style: PropTypes.object,
};
